import { memo } from "react";

import type { RegistrationStatusType } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

import { RegistrationForm } from "./components";

type Props = {
	registrationStatus: ForNodeType<RegistrationStatusType>;
	registrationCode?: ForNodeType<string | null | undefined>;

	onChangeRegistrationStatus: (value: RegistrationStatusType) => void;
	onChangeRegistrationCode: (value: number | undefined) => void;
};

export const InvoiceSystemSettingsMain = memo(
	({ registrationStatus, registrationCode, onChangeRegistrationCode, onChangeRegistrationStatus }: Props) => {
		return (
			<div className="rounded-lg border border-zinc-100 bg-white p-4 lg:p-12">
				<div className="mt-8 flex flex-col gap-y-1">
					<p className="font-semibold">自施設の適格請求書発行事業者登録番号が正しいかを確認できるサイト</p>
					<a
						href="https://www.invoice-kohyo.nta.go.jp/"
						target="_blank"
						className="indent-5 text-link-400 underline-offset-4 hover:underline"
					>
						国税庁 適格請求書発行事業者公表サイト
					</a>
				</div>

				<div className="mt-12 border-b border-zinc-300" />

				<RegistrationForm
					registrationStatus={registrationStatus}
					registrationCode={registrationCode}
					onChangeRegistrationCode={onChangeRegistrationCode}
					onChangeRegistrationStatus={onChangeRegistrationStatus}
				/>
			</div>
		);
	},
);
